import React from 'react';
import Evday_Preprimary_2023 from 'views/Evday_Preprimary_2023';

const AccountGeneralPage = () => {
  return <Evday_Preprimary_2023/>;
};

export default AccountGeneralPage;

// EnvironmentDay2023